import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'react-router-redux';
import { PersistGate } from 'redux-persist/integration/react';

import * as serviceWorker from './serviceWorker';

import { store, persistor, history } from './store';

import App from './containers/app';

// Material UI
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import purple from '@material-ui/core/colors/purple';
import green from '@material-ui/core/colors/green';
import CssBaseline from '@material-ui/core/CssBaseline';

import 'url-search-params-polyfill';
import 'ie-array-find-polyfill';
import 'polyfill-array-includes';

import 'sanitize.css/sanitize.css';
import './index.css';

// A theme with custom primary and secondary color.
// It's optional.
const theme = createMuiTheme({
  breakpoints: {
    keys: ['xs', 'sm', 'md', 'lg', 'xl'],

    values: {
      xs: 0,
      sm: 650,
      md: 960,
      lg: 1280,
      xl: 1920
    }
  },

  palette: {
    primary: {
      //light: purple[300],
      main: '#122B4F'
      //dark: purple[700],
    },
    secondary: {
      light: green[300],
      main: green[500],
      dark: green[700]
    }
  },

  overrides: {
    MuiToolbar: {
      // Name of the styleSheet
      root: {
        // Name of the rule
        background: '#122B4F', //'linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)',
        borderRadius: 3,
        border: 0,
        color: 'white',
        height: 48,
        padding: '0 30px'
        //boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .30)',
      }
    },

    MuiBottomNavigation: {
      root: {
        backgroundColor: '#122B4F'
      }
    },

    MuiBottomNavigationAction: {
      root: {
        color: 'rgba(255,255,255,0.5)'
      },
      selected: {
        color: '#fff !important'
      }
    },

    MuiInput: {
      root: {
        width: '100%'
      }
    },

    MuiFormControl: {
      root: {
        width: '100%'
      }
    },

    MuiGrid: {
      // root: {
      //   margin: 0,
      // }
    },

    MuiAppBar: {
      // Name of the styleSheet
      root: {
        // Name of the rule
        backgroundColor: '#6B7A8F !important' //'linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)',
      }
    }
  }
});

const target = document.querySelector('#root');

render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <ConnectedRouter history={history}>
        <MuiThemeProvider theme={theme}>
          <CssBaseline />
          <App />
        </MuiThemeProvider>
      </ConnectedRouter>
    </PersistGate>
  </Provider>,
  target
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();



// WEBPACK FOOTER //
// ./src/index.js